// extracted by mini-css-extract-plugin
export default {"schoolYearSelector":"schoolYearSelector-dpHG1","selector":"selector-sny35","dropdown":"dropdown-vE2MN","warning":"warning-_ibnI"};